import { get, httpDelete, patch, post } from '../../utils/http';

export const fetchPayroll = ({
  accountId,
  branches,
  from,
  to,
  client,
  asClient,
  withoutOnCost,
  clientIds,
  supplierId,
  employeeIds,
  mode,
  useFreshData = false
}) =>
  get(`/accounts/${accountId}/payroll`, {
    from,
    to,
    employeeIds,
    branches,
    clientIds,
    supplierId,
    options: { client, asClient, withoutOnCost },
    mode,
    useFreshData
  });

export const payrollPayQuery = ({ accountId, employeeSlotId, jobId }) =>
  patch(`accounts/${accountId}/payroll/payQuery`, { employeeSlotId, jobId });

// An absence cannot be pay-queried, only removed — these are the absence counterparts of
// payrollPayQuery. They are also the only delete path the backend exposes for a PTO or a leave record,
// so the employee-profile PTO and leave tabs call them too.
export const removePtoForPayrollQuery = ({ accountId, ptoId }) =>
  httpDelete(`accounts/${accountId}/payroll/pto/${ptoId}`);

export const removeLeaveRecordForPayrollQuery = ({ accountId, leaveRecordId }) =>
  httpDelete(`accounts/${accountId}/payroll/leave-record/${leaveRecordId}`);

export const exportPayrollByDateRange = ({ accountId, branchIds, from, to }) =>
  post(`accounts/${accountId}/payroll/export`, { branchIds, from, to });

export const processPayroll = ({
  accountId,
  employeesSlotsIds = [],
  jobIds = [],
  ptoIds = [],
  leaveRecordIds = [],
  from,
  to,
  branchIds,
  dummy
}) =>
  post(`accounts/${accountId}/payroll/processPayrolls`, {
    from,
    to,
    employeesSlotsIds,
    jobIds,
    ptoIds,
    leaveRecordIds,
    branchIds,
    dummy
  });

export const revertPayrollProcessItems = ({
  accountId,
  employeesSlotsIds = [],
  jobIds = [],
  ptoIds = [],
  leaveRecordIds = []
}) =>
  post(`accounts/${accountId}/payroll/process/revert`, {
    employeesSlotsIds,
    jobIds,
    ptoIds,
    leaveRecordIds
  });
